import url from './apiUrl'
import handleResponse from './handleResponse'

export default (token, payload) => {

    return fetch(`${url()}/users/delete/${payload}`, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Authorization": token
            }
        })
        .then(res => handleResponse(res))
        .catch(err => console.log(err))
}